import React, { FunctionComponent } from 'react';
import { Link } from 'gatsby';
import { formatLink } from '../../utils/formatLink';
import { SanityNavLink } from '../../types/common';
import { ExternalLinkIcon, InternalLinkIcon } from '../Icons';

type NavLinkProps = {
  data: Omit<SanityNavLink, '_id' | '_key'>;
  icon?: boolean;
}

const NavLink: FunctionComponent<NavLinkProps> = ({ data: { name, typeLink, externalLink, page }, icon }) => {
  if (typeLink === 'internal' && page) {
    return (
      <Link to={formatLink(page)}>
        {name}
        {icon ? <InternalLinkIcon /> : null}
      </Link>
    );
  }

  if (typeLink === 'external' && externalLink) {
    return (
      <a href={externalLink} target='_blank' rel='noreferrer noopener'>
        {name}
        {icon ? <ExternalLinkIcon /> : null}
      </a>
    );
  }

  return <a href='#'>{name}</a>
}

export default NavLink;
